import { render, staticRenderFns } from "./ModalAlertNotAccepted.vue?vue&type=template&id=c4adcdb8&scoped=true"
import script from "./ModalAlertNotAccepted.vue?vue&type=script&lang=js"
export * from "./ModalAlertNotAccepted.vue?vue&type=script&lang=js"
import style0 from "./ModalAlertNotAccepted.vue?vue&type=style&index=0&id=c4adcdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4adcdb8",
  null
  
)

export default component.exports